import {
  BRIDGE_CMS_STATIC_URL,
  BRIDGE_PORTAL_SLUG,
} from '../../../siteConfig';

/** Base URL for public SQL-backed CMS (P5 app-service). Empty if unset. */
export function getPortalPublicCmsBase(): string {
  return (process.env.REACT_APP_PORTAL_PUBLIC_CMS_BASE || '').trim().replace(/\/$/, '');
}

/** Portal site slug for The Bridge (EngageOS / P5 CMS) */
export function getBridgePortalSiteSlug(): string {
  return BRIDGE_PORTAL_SLUG;
}

/** @deprecated I-3 fork name */
export const getI3PortalSiteSlug = getBridgePortalSiteSlug;

/** Full URL for GET /api/public/portal/sites/:slug/site-content, or null if SQL CMS disabled. */
export function getPublicPortalSiteContentUrl(): string | null {
  const base = getPortalPublicCmsBase();
  if (!base) return null;
  const slug = getBridgePortalSiteSlug();
  return `${base}/api/public/portal/sites/${encodeURIComponent(slug)}/site-content`;
}

export function getStaticBridgeCmsUrl(): string {
  return BRIDGE_CMS_STATIC_URL;
}

/** @deprecated I-3 fork name */
export const getStaticI3CmsUrl = getStaticBridgeCmsUrl;
